"use strict";
/*
 * Copyright (C) 2017  Universidade de Aveiro, DETI/IEETA, Bioinformatics Group - http://bioinformatics.ua.pt/
 *
 * This file is part of Dicoogle/dicoogle-client-js.
 *
 * Dicoogle/dicoogle-client-js is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Dicoogle/dicoogle-client-js is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with Dicoogle.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tasks = void 0;
const endpoints_1 = __importDefault(require("./endpoints"));
const util_1 = require("./util");
class Tasks {
    constructor(socket) {
        this._socket = socket;
    }
    /**
     * Obtain information about Dicoogle's running (or terminated) tasks.
     * @param callback the callback function
     */
    list(callback) {
        return util_1.andCall(this._socket.get(endpoints_1.default.TASKS)
            .type('application/json')
            .then((resp) => {
            const { body } = resp;
            return body ? {
                tasks: body.results,
                count: body.count
            } : {
                tasks: [],
                count: 0
            };
        }), callback);
    }
    /**
     * Close a terminated task from the list of tasks.
     * @param uid the task's unique ID
     * @param callback the callback function
     */
    close(uid, callback) {
        return util_1.andCallVoid(this._socket.post(endpoints_1.default.TASKS).query({
            uid,
            action: 'delete',
            type: 'close'
        }), callback);
    }
    /**
     * Request that a task is stopped.
     * @param uid the task's unique ID
     * @param callback the callback function
     */
    stop(uid, callback) {
        return util_1.andCallVoid(this._socket.post(endpoints_1.default.TASKS).query({
            uid,
            action: 'delete',
            type: 'stop'
        }), callback);
    }
}
exports.Tasks = Tasks;
//# sourceMappingURL=tasks.js.map